<template>
  <footer id="footer" class="footer">
    <div class="container">
      <a-row>
        <a-col :xs="24" :sm="12" :md="10" :lg="12"
               :order="$Store.Public().isGridMatch('>=',$Enum.GridEnum.SM)?1:2">
          <a-row>
            <a-col :span="24">
              <div class="info">
                <PhoneOutlined :rotate="90" />
                <p>客服咨询：</p>
                <p>010-53655900</p>
              </div>
            </a-col>
            <a-col :span="24">
              <div class="info">
                <MailOutlined />
                <p>邮件咨询：</p>
                <p>market@galaxy-future.com</p>
              </div>
            </a-col>
            <a-col :span="24">
              <div class="info">
                <EnvironmentOutlined />
                <p>联系地址：</p>
                <p>北京市海淀区知春路23号</p>
              </div>
            </a-col>
            <a-col :span="24">
              <div class="channel">
                <a-popover v-for="item in expand.icon">
                  <template #content>{{ item.title }}</template>
                  <a-button type="link" target="_blank"
                            :href="item.href">
                    <span class="iconfont" :class="`icon-${item.name}`" />
                  </a-button>
                </a-popover>
              </div>
            </a-col>
            <a-col :span="24">
              <a-row>
                <a-col :xs="12" :lg="8">
                  <div class="qr">
                    <span>客服咨询</span>
                    <img :src="file.ImageQR_3" alt="客服咨询" />
                  </div>
                </a-col>
                <a-col :xs="12" :lg="8">
                  <div class="qr">
                    <span>微信视频号</span>
                    <img :src="file.ImageQR_4" alt="微信视频号" />
                  </div>
                </a-col>
                <a-col :xs="12" :lg="8">
                  <div class="qr">
                    <span>微信小程序</span>
                    <img :src="file.ImageQR_5" alt="微信小程序" />
                  </div>
                </a-col>
                <!--<a-col :xs="12" :sm="24" :md="12">-->
                <!--    <div class="qr">-->
                <!--        <span>微信公众号</span>-->
                <!--        <img :src="file.ImageQR_1" alt="微信公众号" />-->
                <!--    </div>-->
                <!--</a-col>-->
                <!--<a-col :xs="12" :sm="24" :md="12">-->
                <!--    <div class="qr">-->
                <!--        <span>微信开源群</span>-->
                <!--        <img :src="file.ImageQR_2" alt="微信开源群" />-->
                <!--    </div>-->
                <!--</a-col> -->
              </a-row>
            </a-col>
          </a-row>
        </a-col>
        <a-col class="box_list"
               :xs="24" :sm="{offset:1,span:11}" :md="{offset:1,span:13}" :lg="{offset:0,span:12}"
               :order="$Store.Public().isGridMatch('>=',$Enum.GridEnum.SM)?2:1">
          <a-row :justify="$Store.Public().isGridMatch('>=',$Enum.GridEnum.LG)?'start':'start'">
            <a-col v-for="(v,index) in expand.list" :key="index" :span="$Store.Public().isGridMatch('>=',$Enum.GridEnum.LG)?6:$Store.Public().isGridMatch('<',$Enum.GridEnum.LG)?24:12">
              <div class="list" :style="{ marginLeft: $Store.Public().isGridMatch('>=',$Enum.GridEnum.LG)?  index === 'plan' ? '30px' : '20px':'0px' }">
                <h2>{{ v.name }}</h2>
                <a-list :data-source="v.list" :split="false">
                  <template #renderItem="{ item }">
                    <a-list-item>
                      <Link :name="item.name" :href="item.href+(item.hash?`#${item.hash}`:'')" />
                    </a-list-item>
                  </template>
                </a-list>
              </div>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </div>
  </footer>
  <div class="record">
    <Footer />
  </div>
</template>

<script lang="ts" type="text/tsx">
import { PhoneOutlined, EnvironmentOutlined,MailOutlined } from '@ant-design/icons-vue';

import { DataInterface } from '@interface/public';
import Footer from '@template/_component/footer.vue';
import Link from '@template/page/_component/link.vue';
import ImageQR_1 from '@resource/image/public/qr_public.png';
import ImageQR_2 from '@resource/image/public/qr_enterprise.png';
import ImageQR_3 from '@resource/image/public/qr_assistant.jpg';
import ImageQR_4 from '@resource/image/public/qr_video.png';
import ImageQR_5 from '@resource/image/public/qr_applet.jpg';

export default {
  name: 'page_footer',
  components: {
    PhoneOutlined,
    EnvironmentOutlined,
    MailOutlined,
    Footer,
    Link
  },
  data(): DataInterface {
    return {
      file: {
        ImageQR_1,
        ImageQR_2,
        ImageQR_3,
        ImageQR_4,
        ImageQR_5
      },
      expand: {
        list: {
          saas:{
            name:'SaaS服务',
            list:[
              {
                name: 'AI应用市场',
                href: $Config.Href.store
              },
              // {
              //   name: 'AI应用托管',
              //   href: $Config.Href.cloud
              // }
            ]
          },
          product: {
            name: '产品中心',
            list: [
              {
                name: '互动数字人平台(SaaS)',
                href: $Enum.RouterEnum.ProductAidigitalHuman
              },
              {
                name: '互动数字人平台(私有化)',
                href: $Enum.RouterEnum.ProductPrivateAidigitalHuman
              },
              {
                name: 'AI应用平台AIPilot',
                href: $Enum.RouterEnum.ProductAIPilot
              },
              {
                name: 'AI托管平台InfraPilot',
                href: $Enum.RouterEnum.ProductInfraPilot
              },
              // {
              //   name: '企业云成本管家CostPilot',
              //   href: $Enum.RouterEnum.ProductCostPilot
              // },
              // {
              //   name: '云原生智能运维平台SchedulX',
              //   href: $Enum.RouterEnum.ProductSchedulX
              // },
              // {
              //   name: '云原生智能运维平台SchedulX SaaS版',
              //   href: $Enum.RouterEnum.ProductSchedulXSaaS
              // }
            ]
          },
          plan: {
            name: '解决方案',
            list: [
              {
                name: '运维托管',
                href: $Enum.RouterEnum.PlanTrusteeship
              },
              {
                name: '成本优化',
                href: $Enum.RouterEnum.PlanCost
              },
              // {
              //   name: '咨询服务',
              //   href: $Enum.RouterEnum.Consult
              // },
              // {
              //   name: '智能运维',
              //   href: $Enum.RouterEnum.PlanOperation
              // },
              // {
              //   name: '高峰流量应对',
              //   href: $Enum.RouterEnum.PlanStable
              // },
              // {
              //   name: '东数西算',
              //   href: $Enum.RouterEnum.PlanMigrate
              // },
              // {
              //   name: '多活部署',
              //   href: $Enum.RouterEnum.PlanActive
              // }
            ]
          },
          about: {
            name: '关于我们',
            list: [
              {
                name: '公司介绍',
                href: `${ $Enum.RouterEnum.About }#公司介绍`
              },
              {
                name: '联系我们',
                href: `${ $Enum.RouterEnum.About }#联系我们`
              },
              {
                name: '加入我们',
                href: 'https://www.zhipin.com/gongsir/72519d6ef48c524f1nx_2Nu9EFE~.html?ka=company-jobs'
              }
            ]
          }
        },
        icon: [
          {
            title: '星汉未来官微',
            name: 'weibo',
            href: 'https://weibo.com/galaxyfuture'
          },
          {
            title: '星汉未来官方知乎',
            name: 'zhihu',
            href: 'https://www.zhihu.com/org/xing-yi-wei-lai'
          },
          {
            title: '星汉未来官方B站',
            name: 'bilibili',
            href: 'https://space.bilibili.com/2057006251'
          },
          {
            title: '星汉未来GitHub',
            name: 'github',
            href: 'https://github.com/galaxy-future'
          },
          {
            title: '星汉未来Gitee',
            name: 'gitee',
            href: 'https://gitee.com/galaxy-future'
          }
        ]
      }
    };
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}public/';

.footer {
  overflow: hidden;
  position: relative;
  z-index: 0;
  width: 100%;
  padding: 0 @padding;
  background: @color_5;
  color: @color_white;
  
  .container {
    overflow: hidden;
    position: relative;
    max-width: @grid_xl;
    padding: 35px 0;
    margin: 0 auto;
    .borderBox();
  }
}

.info {
  position: relative;
  margin-bottom: 20px;
  
  p {
    @ph: 15px;
    height: @ph;
    margin: 0 0 0 50px;
    .font(left, @ph, fade(@color_white, 90), 15px);
    
    &:nth-child(2) {
      top: 5px;
      margin-bottom: 10px;
    }
    
    &:nth-child(3) {
      top: 30px;
    }
  }
  
  .anticon {
    @wh: 34px;
    .position(top, 4px);
    width: @wh;
    height: @wh;
    color: @color_white;
    font-size: @wh;
  }
}

.channel {
  position: relative;
  margin-bottom: 10px;
  
  a {
    @as: 36px;
    height: @as;
    padding: 0;
    margin-right: 15px;
    .font(left, @as, fade(@color_white, 90), @as);
    
    .iconfont {
      font-size: @as;
    }
  }
}

.qr {
  position: relative;
  margin: 10px 0 0;
  
  span {
    .font(left, 30px, fade(@color_white, 90), @font_6);
  }
  
  img {
    display: block;
    width: 90%;
    max-width: 160px;
    
  }
}

.box_list {
  position: relative;
  
  // &::before {
  //   content: '';
  //   .position(left);
  //   width: 2px;
  //   .bg('@{src_image}/page/public/border_dotted_v.png', 2px, auto);
  //   background-repeat: repeat-y;
  //   background-position: 0 0;
  // }
  
  .list {
    // min-width: 130px;
    // min-width: 130px;
    min-height: 150px;
    // margin: 0 30px 30px 0;
    // margin: 0 30px 30px 0;
    
    &:deep(h2) {
      color: @color_white !important;
    }
    
    &:deep(.ant-list-item) {
      padding: 8px 0;
      
      a {
        .font(left, 20px, fade(@color_white, 90), @font_6);
        .transition(color @time);
        
        &:hover {
          color: @color_processing;
        }
      }
    }
  }
}

.record {
  position: relative;
  width: 100%;
  padding: 15px 0;
  background: @color_5;
  border-top: 1px solid fade(@color_white, 20);
  .font(center, 30px, fade(@color_white, 90), @font_7);
  
  &:deep(span) {
    color: @color_white;
  }
}

@media screen and (max-width: -1px+@grid_xl) {
  .box_list {
    &::before {
      display: none;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .box_list {
    .list {
      min-width: auto;
      min-height: auto;
      margin: 0 50px 30px 0;
    }
  }
}
</style>